import { useState, useEffect } from 'react';
import debounce from './debounce';
import spacingStyles from '../styling/spacing.module.css';

const {
  header_height: headerHeight,
  mobile_header_height: mobileHeaderHeight,
} = spacingStyles;

/** @param {Window} window */
function isMobileWidth(window) {
  return window.innerWidth <= 1000;
}

function useWindowSize() {
  const isWindowClient = typeof window === 'object';

  const [windowSize, setWindowSize] = useState(
    isWindowClient
      ? {
          headerHeight: parseInt(
            isMobileWidth(window) ? mobileHeaderHeight : headerHeight,
            10,
          ),
          height: window.innerHeight,
          isMobileView: isMobileWidth(window),
          width: window.innerWidth,
        }
      : undefined,
  );

  useEffect(() => {
    // a handler which will be called on change of the screen resize
    function setSize() {
      setWindowSize({
        headerHeight: parseInt(
          isMobileWidth(window) ? mobileHeaderHeight : headerHeight,
          10,
        ),
        height: window.innerHeight,
        isMobileView: isMobileWidth(window),
        width: window.innerWidth,
      });
    }

    if (isWindowClient) {
      const windowResizeHandler = debounce(setSize);
      // register the window resize listener
      window.addEventListener('resize', windowResizeHandler);

      // un-register the listener
      return () => window.removeEventListener('resize', windowResizeHandler);
    }
    return () => {};
  }, [isWindowClient, setWindowSize]);
  return windowSize;
}

export default useWindowSize;
